export const HospitalAcquiredOptions = [
    {
        description: "Abrasion",
        name: "Abrasion",
    },
    {
        description: "Blister",
        name: "Blister",
    },
    {
        description: "Bruise",
        name: "Bruise",
    },
    {
        description: "Burn",
        name: "Burn",
    },
    {
        description: "Dehiscence/Evisceration",
        name: "DehiscenceEvisceration",
    },
    {
        description: "Diaper Dermatitis",
        name: "DiaperDermatitis",
    },
    {
        description: "Fracture",
        name: "Fracture",
    },
    {
        description: "Friction/Shear",
        name: "FrictionShear",
    },
    {
        description: "Infection Surgical Site",
        name: "InfectionSurgicalSite",
    },
    {
        description: "Infection IV line/Central Line/Midline",
        name: "InfectionIVLineCentralLineMidline",
    },
    {
        description: "Infection Urinary",
        name: "InfectionUrinary",
    },
    {
        description: "Laceration",
        name: "Laceration",
    },
    {
        description: "Phlebitis",
        name: "Phlebitis",
    },
    {
        description: "Pressure Ulcer  Stage: I II III IV Unstageable",
        name: "PressureUlcer",
    },
    {
        description: "Puncture",
        name: "Puncture",
    },
    {
        description: "Rash/Hives",
        name: "RashHives",
    },
    {
        description: "Skin Tear/Cut",
        name: "SkinTearCut",
    },
    {
        description: "Wound",
        name: "Wound",
    },
];
